(window.webpackJsonp=window.webpackJsonp||[]).push([[7],{
/***/PuGH:
/***/function(t,e,r){"use strict";
/* harmony export (binding) */r.d(e,"a",(function(){return y}));
/* harmony import */var o=r("sBkJ"),s=r("dv22");
/* harmony import */
/**
 * @fileoverview
 * @suppress {checkPrototypalTypes}
 * @license Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */
const i=/:host\(:dir\((ltr|rtl)\)\)/g,a=/([\s\w-#\.\[\]\*]*):dir\((ltr|rtl)\)/g,n=/:dir\((?:ltr|rtl)\)/,l=Boolean(window.ShadyDOM&&window.ShadyDOM.inUse),c=[];
/** @type {?MutationObserver} */
let p=null,d="";function h(){d=document.documentElement.getAttribute("dir")}
/**
 * @param {!Polymer_DirMixin} instance Instance to set RTL status on
 */function u(t){if(!t.__autoDirOptOut){
/** @type {!HTMLElement} */
t.setAttribute("dir",d)}}function _(){h(),d=document.documentElement.getAttribute("dir");for(let t=0;t<c.length;t++)u(c[t])}
/**
 * Element class mixin that allows elements to use the `:dir` CSS Selector to
 * have text direction specific styling.
 *
 * With this mixin, any stylesheet provided in the template will transform
 * `:dir` into `:host([dir])` and sync direction with the page via the
 * element's `dir` attribute.
 *
 * Elements can opt out of the global page text direction by setting the `dir`
 * attribute directly in `ready()` or in HTML.
 *
 * Caveats:
 * - Applications must set `<html dir="ltr">` or `<html dir="rtl">` to sync
 *   direction
 * - Automatic left-to-right or right-to-left styling is sync'd with the
 *   `<html>` element only.
 * - Changing `dir` at runtime is supported.
 * - Opting out of the global direction styling is permanent
 *
 * @mixinFunction
 * @polymer
 * @appliesMixin PropertyAccessors
 * @template T
 * @param {function(new:T)} superClass Class to apply mixin to.
 * @return {function(new:T)} superClass with mixin applied.
 */
const y=Object(s.a)(t=>{l||p||(h(),p=new MutationObserver(_),p.observe(document.documentElement,{attributes:!0,attributeFilter:["dir"]}))
/**
   * @constructor
   * @implements {Polymer_PropertyAccessors}
   * @private
   */;const e=Object(o.a)(t);
/**
   * @polymer
   * @mixinClass
   * @implements {Polymer_DirMixin}
   */class r extends e{
/**
     * @param {string} cssText .
     * @param {string} baseURI .
     * @return {string} .
     * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
     * @nocollapse
     */
static _processStyleText(t,r){
// TODO(https://github.com/google/closure-compiler/issues/3240):
//     Change back to just super.methodCall()
return t=e._processStyleText.call(this,t,r),!l&&n.test(t)&&(t=this._replaceDirInCssText(t),this.__activateDir=!0),t}
/**
     * Replace `:dir` in the given CSS text
     *
     * @param {string} text CSS text to replace DIR
     * @return {string} Modified CSS
     * @nocollapse
     */static _replaceDirInCssText(t){let e=t;return e=e.replace(i,':host([dir="$1"])'),e=e.replace(a,':host([dir="$2"]) $1'),e}constructor(){super(),
/** @type {boolean} */
this.__autoDirOptOut=!1}
/**
     * @override
     * @suppress {invalidCasts} Closure doesn't understand that `this` is an
     *     HTMLElement
     * @return {void}
     */ready(){super.ready(),this.__autoDirOptOut=
/** @type {!HTMLElement} */
this.hasAttribute("dir")}
/**
     * @override
     * @suppress {missingProperties} If it exists on elementBase, it can be
     *   super'd
     * @return {void}
     */connectedCallback(){e.prototype.connectedCallback&&super.connectedCallback(),this.constructor.__activateDir&&(p&&p.takeRecords().length&&_(),c.push(this),u(this))}
/**
     * @override
     * @suppress {missingProperties} If it exists on elementBase, it can be
     *   super'd
     * @return {void}
     */disconnectedCallback(){if(e.prototype.disconnectedCallback&&super.disconnectedCallback(),this.constructor.__activateDir){const t=c.indexOf(this);t>-1&&c.splice(t,1)}}}return r.__activateDir=!1,r});
/***/},
/***/Wbgf:
/***/function(t,e,r){"use strict";
/* unused harmony export version */
/* harmony export (binding) */r.d(e,"b",(function(){return d})),
/* harmony export (binding) */r.d(e,"a",(function(){return h}));
/* unused harmony export updateStyles */
/* harmony import */r("SRZj");
/* harmony import */var o=r("H/aU"),s=r("dv22"),i=r("E3QQ"),a=r("sBZK"),n=r("O5q1"),l=r("5HyR"),c=r("K6QC"),p=r("MDMB");
/**
 * @fileoverview
 * @suppress {checkPrototypalTypes}
 * @license Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */
/**
 * Current Polymer version in Semver notation.
 * @type {string} Semver notation of the current version of Polymer.
 */
const d=window.ShadyCSS&&window.ShadyCSS.cssBuild,h=Object(s.a)(t=>{
/**
   * @constructor
   * @implements {Polymer_PropertyEffects}
   * @implements {Polymer_PropertiesMixin}
   * @extends {HTMLElement}
   * @private
   */
const e=Object(c.a)(Object(l.a)(t));
/**
   * Returns a list of properties with default values.
   * This list is created as an optimization since it is a subset of
   * the list returned from `_properties`.
   * This list is used in `_initializeProperties` to set property defaults.
   *
   * @param {PolymerElementConstructor} constructor Element class
   * @return {PolymerElementProperties} Flattened properties for this class
   *   that have default values
   * @private
   */
/**
   * @polymer
   * @mixinClass
   * @unrestricted
   * @implements {Polymer_ElementMixin}
   * @extends {polymerElementBase}
   */
return class extends e{
/**
     * Current Polymer version in Semver notation.
     * @type {string} Semver notation of the current version of Polymer.
     * @nocollapse
     */
static get polymerElementVersion(){return"3.4.1"}
/**
     * Override of PropertiesMixin _finalizeClass to create observers and
     * find the template.
     * @return {void}
     * @protected
     * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
     * @nocollapse
     */static _finalizeClass(){
// TODO(https://github.com/google/closure-compiler/issues/3240):
//     Change back to just super.methodCall()
e._finalizeClass.call(this);const t=((r=this).hasOwnProperty(JSCompiler_renameProperty("__ownObservers",r))||(r.__ownObservers=r.hasOwnProperty(JSCompiler_renameProperty("observers",r))?
/** @type {PolymerElementConstructor} */
r.observers:null),r.__ownObservers);
/**
   * Returns a memoized version of the `observers` array.
   * @param {PolymerElementConstructor} constructor Element class
   * @return {Array} Array containing own observers for the given class
   * @protected
   */
var r;
/**
   * Creates effects for a property.
   *
   * Note, once a property has been set to
   * `readOnly`, `computed`, `reflectToAttribute`, or `notify`
   * these values may not be changed. For example, a subclass cannot
   * alter these settings. However, additional `observers` may be added
   * by subclasses.
   *
   * The info object should contain property metadata as follows:
   *
   * * `type`: {function} type to which an attribute matching the property
   * is deserialized. Note the property is camel-cased from a dash-cased
   * attribute. For example, 'foo-bar' attribute is deserialized to a
   * property named 'fooBar'.
   *
   * * `readOnly`: {boolean} creates a readOnly property and
   * makes a private setter for the private of the form '_setFoo' for a
   * property 'foo',
   *
   * * `computed`: {string} creates a computed property. A computed property
   * is also automatically set to `readOnly: true`. The value is calculated
   * by running a method and arguments parsed from the given string. For
   * example 'compute(foo)' will compute a given property when the
   * 'foo' property changes by executing the 'compute' method. This method
   * must return the computed value.
   *
   * * `reflectToAttribute`: {boolean} If true, the property value is reflected
   * to an attribute of the same name. Note, the attribute is dash-cased
   * so a property named 'fooBar' is reflected as 'foo-bar'.
   *
   * * `notify`: {boolean} sends a non-bubbling notification event when
   * the property changes. For example, a property named 'foo' sends an
   * event named 'foo-changed' with `event.detail` set to the value of
   * the property.
   *
   * * observer: {string} name of a method that runs when the property
   * changes. The arguments of the method are (value, previousValue).
   *
   * Note: Users may want control over modifying property
   * effects via subclassing. For example, a user might want to make a
   * reflectToAttribute property not do so in a subclass. We've chosen to
   * disable this because it leads to additional complication.
   * For example, a readOnly effect generates a special setter. If a subclass
   * disables the effect, the setter would fail unexpectedly.
   * Based on feedback, we may want to try to make effects more malleable
   * and/or provide an advanced api for manipulating them.
   *
   * @param {!PolymerElement} proto Element class prototype to add accessors
   *   and effects to
   * @param {string} name Name of the property.
   * @param {Object} info Info object from which to create property effects.
   * Supported keys:
   * @param {Object} allProps Flattened map of all properties defined in this
   *   element (including inherited properties)
   * @return {void}
   * @private
   */t&&this.createObservers(t,this._properties),this._prepareTemplate()}
/** @nocollapse */static _prepareTemplate(){
// note: create "working" template that is finalized at instance time
let t=
/** @type {PolymerElementConstructor} */
this.template;t&&("string"==typeof t?(console.error("template getter must return HTMLTemplateElement"),t=null):o.e||(t=t.cloneNode(!0)))
/** @override */,this.prototype._template=t}
/**
     * Override of PropertiesChanged createProperties to create accessors
     * and property effects for all of the properties.
     * @param {!Object} props .
     * @return {void}
     * @protected
     * @nocollapse
     */static createProperties(t){for(let i in t)e=
/** @type {?} */
this.prototype,r=i,o=t[i],s=t,
// computed forces readOnly...
o.computed&&(o.readOnly=!0),// Note, since all computed properties are readOnly, this prevents
// adding additional computed property effects (which leads to a confusing
// setup where multiple triggers for setting a property)
// While we do have `hasComputedEffect` this is set on the property's
// dependencies rather than itself.
o.computed&&(e._hasReadOnlyEffect(r)?console.warn(`Cannot redefine computed property '${r}'.`):e._createComputedProperty(r,o.computed,s)),o.readOnly&&!e._hasReadOnlyEffect(r)?e._createReadOnlyProperty(r,!o.computed):!1===o.readOnly&&e._hasReadOnlyEffect(r)&&console.warn(`Cannot make readOnly property '${r}' non-readOnly.`),o.reflectToAttribute&&!e._hasReflectEffect(r)?e._createReflectedProperty(r):!1===o.reflectToAttribute&&e._hasReflectEffect(r)&&console.warn(`Cannot make reflected property '${r}' non-reflected.`),o.notify&&!e._hasNotifyEffect(r)?e._createNotifyingProperty(r):!1===o.notify&&e._hasNotifyEffect(r)&&console.warn(`Cannot make notify property '${r}' non-notify.`),// always add observer
o.observer&&e._createPropertyObserver(r,o.observer,s[o.observer]),// always create the mapping from attribute back to property for deserialization.
e._addPropertyToAttributeMap(r);var e,r,o,s;
/**
   * Process all style elements in the element template. Styles with the
   * `include` attribute are processed such that any styles in
   * the associated "style modules" are included in the element template.
   * @param {PolymerElementConstructor} klass Element class
   * @param {!HTMLTemplateElement} template Template to process
   * @param {string} is Name of element
   * @param {string} baseURI Base URI for element
   * @private
   */}
/**
     * Creates observers for the given `observers` array.
     * Leverages `PropertyEffects` to create observers.
     * @param {Object} observers Array of observer descriptors for
     *   this class
     * @param {Object} dynamicFns Object containing keys for any properties
     *   that are functions and should trigger the effect when the function
     *   reference is changed
     * @return {void}
     * @protected
     * @nocollapse
     */static createObservers(t,e){const r=this.prototype;for(let o=0;o<t.length;o++)r._createMethodObserver(t[o],e)}
/**
     * Returns the template that will be stamped into this element's shadow root.
     *
     * If a `static get is()` getter is defined, the default implementation will
     * return the first `<template>` in a `dom-module` whose `id` matches this
     * element's `is` (note that a `_template` property on the class prototype
     * takes precedence over the `dom-module` template, to maintain legacy
     * element semantics; a subclass will subsequently fall back to its super
     * class template if neither a `prototype._template` or a `dom-module` for
     * the class's `is` was found).
     *
     * Users may override this getter to return an arbitrary template
     * (in which case the `is` getter is unnecessary). The template returned
     * must be an `HTMLTemplateElement`.
     *
     * Note that when subclassing, if the super class overrode the default
     * implementation and the subclass would like to provide an alternate
     * template via a `dom-module`, it should override this getter and
     * return `DomModule.import(this.is, 'template')`.
     *
     * If a subclass would like to modify the super class template, it should
     * clone it rather than modify it in place.  If the getter does expensive
     * work such as cloning/modifying a template, it should memoize the
     * template for maximum performance:
     *
     *   let memoizedTemplate;
     *   class MySubClass extends MySuperClass {
     *     static get template() {
     *       if (!memoizedTemplate) {
     *         memoizedTemplate = super.template.cloneNode(true);
     *         let subContent = document.createElement('div');
     *         subContent.textContent = 'This came from MySubClass';
     *         memoizedTemplate.content.appendChild(subContent);
     *       }
     *       return memoizedTemplate;
     *     }
     *   }
     *
     * @return {!HTMLTemplateElement|string} Template to be stamped
     * @nocollapse
     */static get template(){
// Explanation of template-related properties:
// - constructor.template (this getter): the template for the class.
//     This can come from the prototype (for legacy elements), from a
//     dom-module, or from the super class's template (or can be overridden
//     altogether by the user)
// - constructor._template: memoized version of constructor.template
// - prototype._template: working template for the element, which will be
//     parsed and modified in place. It is a cloned version of
//     constructor.template, saved in _finalizeClass(). Note that before
//     this getter is called, for legacy elements this could be from a
//     _template field on the info object passed to Polymer(), a behavior,
//     or set in registered(); once the static getter runs, a clone of it
//     will overwrite it on the prototype as the working template.
if(!this.hasOwnProperty(JSCompiler_renameProperty("_template",this))){const t=this.prototype.hasOwnProperty(JSCompiler_renameProperty("_template",this.prototype))?this.prototype._template:void 0;this._template=// If user has put template on prototype (e.g. in legacy via registered
// callback or info object), prefer that first. Note that `null` is
// used as a sentinel to indicate "no template" and can be used to
// override a super template, whereas `undefined` is used as a
// sentinel to mean "fall-back to default template lookup" via
// dom-module and/or super.template.
void 0!==t?t:// Look in dom-module associated with this element's is
this.hasOwnProperty(JSCompiler_renameProperty("is",this))&&
/**
   * Look up template from dom-module for element
   *
   * @param {string} is Element name to look up
   * @return {?HTMLTemplateElement|undefined} Template found in dom module, or
   *   undefined if not found
   * @protected
   */
function(t){let e=null;// Under strictTemplatePolicy in 3.x+, dom-module lookup is only allowed
// when opted-in via allowTemplateFromDomModule
if(t&&(!o.n||o.a)&&(e=
/** @type {?HTMLTemplateElement} */
n.a.import(t,"template"),o.n&&!e))throw new Error("strictTemplatePolicy: expecting dom-module or null template for "+t);return e}(
/** @type {PolymerElementConstructor}*/
this.is)||// Next look for superclass template (call the super impl this
// way so that `this` points to the superclass)
Object.getPrototypeOf(
/** @type {PolymerElementConstructor}*/
this.prototype).constructor.template}return this._template}
/**
     * Set the template.
     *
     * @param {!HTMLTemplateElement|string} value Template to set.
     * @nocollapse
     */static set template(t){this._template=t}
/**
     * Path matching the url from which the element was imported.
     *
     * This path is used to resolve url's in template style cssText.
     * The `importPath` property is also set on element instances and can be
     * used to create bindings relative to the import path.
     *
     * For elements defined in ES modules, users should implement
     * `static get importMeta() { return import.meta; }`, and the default
     * implementation of `importPath` will  return `import.meta.url`'s path.
     * For elements defined in HTML imports, this getter will return the path
     * to the document containing a `dom-module` element matching this
     * element's static `is` property.
     *
     * Note, this path should contain a trailing `/`.
     *
     * @return {string} The import path for this element class
     * @suppress {missingProperties}
     * @nocollapse
     */static get importPath(){if(!this.hasOwnProperty(JSCompiler_renameProperty("_importPath",this))){const t=this.importMeta;if(t)this._importPath=Object(a.a)(t.url);else{const t=n.a.import(
/** @type {PolymerElementConstructor} */
this.is);this._importPath=t&&t.assetpath||Object.getPrototypeOf(
/** @type {PolymerElementConstructor}*/
this.prototype).constructor.importPath}}return this._importPath}constructor(){super(),
/** @type {HTMLTemplateElement} */
this._template,
/** @type {string} */
this._importPath,
/** @type {string} */
this.rootPath,
/** @type {string} */
this.importPath,
/** @type {StampedTemplate | HTMLElement | ShadowRoot} */
this.root,
/** @type {!Object<string, !Element>} */
this.$}
/**
     * Overrides the default `PropertyAccessors` to ensure class
     * metaprogramming related to property accessors and effects has
     * completed (calls `finalize`).
     *
     * It also initializes any property defaults provided via `value` in
     * `properties` metadata.
     *
     * @return {void}
     * @override
     * @suppress {invalidCasts,missingProperties} go/missingfnprops
     */_initializeProperties(){this.constructor.finalize(),// note: finalize template when we have access to `localName` to
// avoid dependence on `is` for polyfilling styling.
this.constructor._finalizeTemplate(
/** @type {!HTMLElement} */
this.localName),super._initializeProperties(),// set path defaults
this.rootPath=o.k,this.importPath=this.constructor.importPath;// apply property defaults...
let t=function(t){if(!t.hasOwnProperty(JSCompiler_renameProperty("__propertyDefaults",t))){t.__propertyDefaults=null;let e=t._properties;for(let r in e){let o=e[r];"value"in o&&(t.__propertyDefaults=t.__propertyDefaults||{},t.__propertyDefaults[r]=o)}}return t.__propertyDefaults}(this.constructor);if(t)for(let e in t){let r=t[e];if(this._canApplyPropertyDefault(e)){let t="function"==typeof r.value?r.value.call(this):r.value;// Set via `_setProperty` if there is an accessor, to enable
// initializing readOnly property defaults
this._hasAccessor(e)?this._setPendingProperty(e,t,!0):this[e]=t}}}
/**
     * Determines if a property dfeault can be applied. For example, this
     * prevents a default from being applied when a property that has no
     * accessor is overridden by its host before upgrade (e.g. via a binding).
     * @override
     * @param {string} property Name of the property
     * @return {boolean} Returns true if the property default can be applied.
     */_canApplyPropertyDefault(t){return!this.hasOwnProperty(t)}
/**
     * Gather style text for a style element in the template.
     *
     * @param {string} cssText Text containing styling to process
     * @param {string} baseURI Base URI to rebase CSS paths against
     * @return {string} The processed CSS text
     * @protected
     * @nocollapse
     */static _processStyleText(t,e){return Object(a.b)(t,e)}
/**
    * Configures an element `proto` to function with a given `template`.
    * The element name `is` and extends `ext` must be specified for ShadyCSS
    * style scoping.
    *
    * @param {string} is Tag name (or type extension name) for this element
    * @return {void}
    * @protected
    * @nocollapse
    */static _finalizeTemplate(t){
/** @const {HTMLTemplateElement} */
const e=this.prototype._template;if(e&&!e.__polymerFinalized){e.__polymerFinalized=!0;const r=this.importPath;// e.g. support `include="module-name"`, and ShadyCSS
!function(t,e,r,s){if(!d){const o=e.content.querySelectorAll("style"),a=Object(i.c)(e),n=Object(i.b)(r),l=e.content.firstElementChild;for(let r=0;r<n.length;r++){let o=n[r];o.textContent=t._processStyleText(o.textContent,s),e.content.insertBefore(o,l)}// keep track of the last "concrete" style in the template we have encountered
let c=0;// ensure all gathered styles are actually in this template.
for(let e=0;e<a.length;e++){let r=a[e],i=o[c];// if the style is not in this template, it's been "included" and
// we put a clone of it in the template before the style that included it
i!==r?(r=r.cloneNode(!0),i.parentNode.insertBefore(r,i)):c++,r.textContent=t._processStyleText(r.textContent,s)}}// Support for `adoptedStylesheets` relies on using native Shadow DOM
// and built CSS. Built CSS is required because runtime transformation of
// `@apply` is not supported. This is because ShadyCSS relies on being able
// to update a `style` element in the element template and this is
// removed when using `adoptedStyleSheets`.
// Note, it would be more efficient to allow style includes to become
// separate stylesheets; however, because of `@apply` these are
// potentially not shareable and sharing the ones that could be shared
// would require some coordination. To keep it simple, all the includes
// and styles are collapsed into a single shareable stylesheet.
if(window.ShadyCSS&&window.ShadyCSS.prepareTemplate(e,r),o.r&&d&&o.o){
// Remove styles in template and make a shareable stylesheet
const r=e.content.querySelectorAll("style");if(r){let e="";Array.from(r).forEach(t=>{e+=t.textContent,t.parentNode.removeChild(t)}),t._styleSheet=new CSSStyleSheet,t._styleSheet.replaceSync(e)}}}(this,e,t,r?Object(a.c)(r):""),this.prototype._bindTemplate(e)}}
/**
     * Provides a default implementation of the standard Custom Elements
     * `connectedCallback`.
     *
     * The default implementation enables the property effects system and
     * flushes any pending properties, and updates shimmed CSS properties
     * when using the ShadyCSS scoping/custom properties polyfill.
     *
     * @override
     * @suppress {missingProperties, invalidCasts} Super may or may not
     *     implement the callback
     * @return {void}
     */connectedCallback(){window.ShadyCSS&&this._template&&window.ShadyCSS.styleElement(
/** @type {!HTMLElement} */
this),super.connectedCallback()}
/**
     * Stamps the element template.
     *
     * @return {void}
     * @override
     */ready(){this._template&&(this.root=this._stampTemplate(this._template),this.$=this.root.$),super.ready()}
/**
     * Implements `PropertyEffects`'s `_readyClients` call. Attaches
     * element dom by calling `_attachDom` with the dom stamped from the
     * element's template via `_stampTemplate`. Note that this allows
     * client dom to be attached to the element prior to any observers
     * running.
     *
     * @return {void}
     * @override
     */_readyClients(){this._template&&(this.root=this._attachDom(
/** @type {StampedTemplate} */
this.root)),// The super._readyClients here sets the clients initialized flag.
// We must wait to do this until after client dom is created/attached
// so that this flag can be checked to prevent notifications fired
// during this process from being handled before clients are ready.
super._readyClients()}
/**
     * Attaches an element's stamped dom to itself. By default,
     * this method creates a `shadowRoot` and adds the dom to it.
     * However, this method may be overridden to allow an element
     * to put its dom in another location.
     *
     * @override
     * @throws {Error}
     * @suppress {missingReturn}
     * @param {StampedTemplate} dom to attach to the element.
     * @return {ShadowRoot} node to which the dom has been attached.
     */_attachDom(t){const e=Object(p.a)(this);if(e.attachShadow)return t?(e.shadowRoot||(e.attachShadow({mode:"open",shadyUpgradeFragment:t}),e.shadowRoot.appendChild(t),// When `adoptedStyleSheets` is supported a stylesheet is made
// available on the element constructor.
this.constructor._styleSheet&&(e.shadowRoot.adoptedStyleSheets=[this.constructor._styleSheet])),o.q&&window.ShadyDOM&&window.ShadyDOM.flushInitial(e.shadowRoot),e.shadowRoot):null;throw new Error("ShadowDOM not available. PolymerElement can create dom as children instead of in ShadowDOM by setting `this.root = this;` before `ready`.")}
/**
     * When using the ShadyCSS scoping and custom property shim, causes all
     * shimmed styles in this element (and its subtree) to be updated
     * based on current custom property values.
     *
     * The optional parameter overrides inline custom property styles with an
     * object of properties where the keys are CSS properties, and the values
     * are strings.
     *
     * Example: `this.updateStyles({'--color': 'blue'})`
     *
     * These properties are retained unless a value of `null` is set.
     *
     * Note: This function does not support updating CSS mixins.
     * You can not dynamically change the value of an `@apply`.
     *
     * @override
     * @param {Object=} properties Bag of custom property key/values to
     *   apply to this element.
     * @return {void}
     * @suppress {invalidCasts}
     */updateStyles(t){window.ShadyCSS&&window.ShadyCSS.styleSubtree(
/** @type {!HTMLElement} */
this,t)}
/**
     * Rewrites a given URL relative to a base URL. The base URL defaults to
     * the original location of the document containing the `dom-module` for
     * this element. This method will return the same URL before and after
     * bundling.
     *
     * Note that this function performs no resolution for URLs that start
     * with `/` (absolute URLs) or `#` (hash identifiers).  For general purpose
     * URL resolution, use `window.URL`.
     *
     * @override
     * @param {string} url URL to resolve.
     * @param {string=} base Optional base URL to resolve against, defaults
     * to the element's `importPath`
     * @return {string} Rewritten URL relative to base
     */resolveUrl(t,e){return!e&&this.importPath&&(e=Object(a.c)(this.importPath)),Object(a.c)(t,e)}
/**
     * Overrides `PropertyEffects` to add map of dynamic functions on
     * template info, for consumption by `PropertyEffects` template binding
     * code. This map determines which method templates should have accessors
     * created for them.
     *
     * @param {!HTMLTemplateElement} template Template
     * @param {!TemplateInfo} templateInfo Template metadata for current template
     * @param {!NodeInfo} nodeInfo Node metadata for current template.
     * @return {boolean} .
     * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
     * @nocollapse
     */static _parseTemplateContent(t,r,o){// TODO(https://github.com/google/closure-compiler/issues/3240):
//     Change back to just super.methodCall()
return r.dynamicFns=r.dynamicFns||this._properties,e._parseTemplateContent.call(this,t,r,o)}
/**
     * Overrides `PropertyEffects` to warn on use of undeclared properties in
     * template.
     *
     * @param {Object} templateInfo Template metadata to add effect to
     * @param {string} prop Property that should trigger the effect
     * @param {Object=} effect Effect metadata object
     * @return {void}
     * @protected
     * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
     * @nocollapse
     */static _addTemplatePropertyEffect(t,r,s){// TODO(https://github.com/google/closure-compiler/issues/3240):
//     Change back to just super.methodCall()
// Warn if properties are used in template without being declared.
// Properties must be listed in `properties` to be included in
// `observedAttributes` since CE V1 reads that at registration time, and
// since we want to keep template parsing lazy, we can't automatically
// add undeclared properties used in templates to `observedAttributes`.
// The warning is only enabled in `legacyOptimizations` mode, since
// we don't want to spam existing users who might have adopted the
// shorthand when attribute deserialization is not important.
return!o.g||r in this._properties||s.info.part.signature&&s.info.part.signature.static||s.info.part.hostProp||t.nestedTemplate||console.warn(`Property '${r}' used in template but not declared in 'properties'; attribute will not be observed.`),e._addTemplatePropertyEffect.call(this,t,r,s)}}})},
/***/nduU:
/***/function(t,e,r){"use strict";
/* harmony export (binding) */r.d(e,"a",(function(){return i}));
/* harmony import */r("SRZj");
/* harmony import */var o=r("dv22"),s=r("hLn4");
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/**
 * Element class mixin that provides API for adding Polymer's cross-platform
 * gesture events to nodes.
 *
 * The API is designed to be compatible with override points implemented
 * in `TemplateStamp` such that declarative event listeners in
 * templates will support gesture events when this mixin is applied along with
 * `TemplateStamp`.
 *
 * @mixinFunction
 * @polymer
 * @summary Element class mixin that provides API for adding Polymer's
 *   cross-platform gesture events to nodes
 * @template T
 * @param {function(new:T)} superClass Class to apply mixin to.
 * @return {function(new:T)} superClass with mixin applied.
 */
const i=Object(o.a)(t=>
/**
   * @polymer
   * @mixinClass
   * @implements {Polymer_GestureEventListeners}
   */
class extends t{
/**
     * Add the event listener to the node if it is a gestures event.
     *
     * @param {!EventTarget} node Node to add event listener to
     * @param {string} eventName Name of event
     * @param {function(!Event):void} handler Listener function to add
     * @return {void}
     * @override
     */
_addEventListenerToNode(t,e,r){Object(s.a)(t,e,r)||super._addEventListenerToNode(t,e,r)}
/**
     * Remove the event listener to the node if it is a gestures event.
     *
     * @param {!EventTarget} node Node to remove event listener from
     * @param {string} eventName Name of event
     * @param {function(!Event):void} handler Listener function to remove
     * @return {void}
     * @override
     */_removeEventListenerFromNode(t,e,r){Object(s.e)(t,e,r)||super._removeEventListenerFromNode(t,e,r)}});
/***/},
/***/pczb:
/***/function(t,e,r){"use strict";
/* harmony export (binding) */r.d(e,"b",(function(){return a})),
/* harmony export (binding) */r.d(e,"a",(function(){return n}));
/* harmony import */var o=r("Wbgf"),s=r("dv22"),i=r("MDMB");
/* harmony import */
/**
 * @fileoverview
 * @suppress {checkPrototypalTypes}
 * @license Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */
const a=t=>{for(;t;){const e=Object.getOwnPropertyDescriptor(t,"observedAttributes");if(e)return e.get;t=Object.getPrototypeOf(t.prototype).constructor}return()=>[]},n=Object(s.a)(t=>{
/**
   * @constructor
   * @implements {Polymer_ElementMixin}
   * @extends {HTMLElement}
   * @private
   */
const e=Object(o.a)(t);// Work around for closure bug #126934458. Using `super` in a property
// getter does not work so instead we search the Base prototype for an
// implementation of observedAttributes so that we can override and call
// the `super` getter. Note, this is done one time ever because we assume
// that `Base` is always comes from `Polymer.LegacyElementMixn`.
let r=a(e);
/**
   * @polymer
   * @mixinClass
   * @implements {Polymer_DisableUpgradeMixin}
   */return class extends e{constructor(){super(),
/** @type {boolean|undefined} */
this.__isUpgradeDisabled}static get observedAttributes(){return r.call(this).concat("disable-upgrade")}// Prevent element from initializing properties when it's upgrade disabled.
/** @override */
_initializeProperties(){this.hasAttribute("disable-upgrade")?this.__isUpgradeDisabled=!0:super._initializeProperties()}// Prevent element from enabling properties when it's upgrade disabled.
// Normally overriding connectedCallback would be enough, but dom-* elements
/** @override */
_enableProperties(){this.__isUpgradeDisabled||super._enableProperties()}// If the element starts upgrade-disabled and a property is set for
// which an accessor exists, the default should not be applied.
// This additional check is needed because defaults are applied via
// `_initializeProperties` which is called after initial properties
// have been set when the element starts upgrade-disabled.
/** @override */
_canApplyPropertyDefault(t){return super._canApplyPropertyDefault(t)&&!(this.__isUpgradeDisabled&&this._isPropertyPending(t))}
/**
     * @override
     * @param {string} name Attribute name.
     * @param {?string} old The previous value for the attribute.
     * @param {?string} value The new value for the attribute.
     * @param {?string} namespace The XML namespace for the attribute.
     * @return {void}
     */attributeChangedCallback(t,e,r,o){"disable-upgrade"==t?
// When disable-upgrade is removed, intialize properties and
// provoke connectedCallback if the element is already connected.
this.__isUpgradeDisabled&&null==r&&(super._initializeProperties(),this.__isUpgradeDisabled=!1,Object(i.a)(this).isConnected&&super.connectedCallback()):super.attributeChangedCallback(t,e,r,
/** @type {null|string} */
o)}// Prevent element from connecting when it's upgrade disabled.
// This prevents user code in `attached` from being called.
/** @override */
connectedCallback(){this.__isUpgradeDisabled||super.connectedCallback()}// Prevent element from disconnecting when it's upgrade disabled.
// This avoids allowing user code `detached` from being called without a
// paired call to `attached`.
/** @override */
disconnectedCallback(){this.__isUpgradeDisabled||super.disconnectedCallback()}}})}}]);